<template>
  <font-awesome-icon
    icon="check-double"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheckDouble } from '@fortawesome/free-solid-svg-icons'

library.add(faCheckDouble)

export default {
  name: 'CoozzyDoubleCheckIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
